import React, { useEffect, useState } from "react";
import "./itrreportsprint.css";
import axios from "axios";

import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";

// ✅ Register fonts
Font.register({
  family: "Lato-Italic",
  src: LatoItalicFont,
});
Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});

const Itrreportsprint = () => {
  const { t, i18n } = useTranslation();

  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";

  // ✅ apply font without changing your StyleSheet
  const F = (styleObj) => [styleObj, { fontFamily: fontBase }];

  // ✅ must be array (you use .length + .map)
  const [customerData, setCustomerData] = useState([]);
  const [PreviousAmt, setPreviousAmt] = useState(0);

  let totals = {};

  useEffect(() => {
    let phplanding = "";
    if (localStorage.getItem("irpttype") === "retan") {
      phplanding = "getretanmedireport.php";
    } else if (localStorage.getItem("irpttype") === "karj") {
      phplanding = "getkarjreportbydate.php";
    } else if (localStorage.getItem("irpttype") === "sanghpur") {
      phplanding = "getsanghpurreportbydate.php";
    } else if (localStorage.getItem("irpttype") === "shares") {
      phplanding = "getsharesreportbydate.php";
    }

    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);
    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        const arr = Array.isArray(response.data) ? response.data : [];
        setCustomerData(arr);

        // (your old condition kept – though it's unrelated here)
        if (localStorage.getItem("khrtype") === "dreport" && arr.length > 0) {
          setPreviousAmt(arr[0].previousamt);
        }
      })
      .catch((err) => {
        console.log(err);
        setCustomerData([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function formatDate(inputDate) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(inputDate).toLocaleDateString("en-US", options);
  }

  // ✅ totals used for retan / karj / sanghpur / shares
  const irpttype = localStorage.getItem("irpttype");
  if (irpttype === "retan" || irpttype === "karj" || irpttype === "sanghpur" || irpttype === "shares") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.amt || 0), 0),
      };
    } else {
      totals = { tamt: 0 };
    }
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  const periodLine = t("Itrreportsprint.header.period", {
    from: formatDate(localStorage.getItem("date1print")),
    to: formatDate(localStorage.getItem("date2print")),
  });

  return (
    <PDFViewer className="pdf">
      <Document>
        {Array.isArray(customerData) && customerData.length > 0 ? (
          irpttype === "retan" ? (
            <Page size="A4">
              <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
              <Text style={F(styles.latoText2)}>{t("Itrreportsprint.titles.retan")}</Text>
              <Text style={F(styles.latoText2)}>{periodLine}</Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.date")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.account")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.name")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.type")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{t("Itrreportsprint.table.category")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{t("Itrreportsprint.table.amount")}</Text>
                </View>

                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRow}>
                    <Text style={F(styles.tableCell)}>{formatDate(rowData.date)}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.kno}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.type}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.etype}</Text>
                    <Text style={F(styles.tableCell)}>{parseFloat(rowData.amt).toFixed(2)}</Text>
                  </View>
                ))}

                <View style={styles.tableRow3}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.total")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                </View>
              </View>
            </Page>
          ) : irpttype === "shares" ? (
            <Page size="A4">
              <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
              <Text style={F(styles.latoText2)}>{t("Itrreportsprint.titles.shares")}</Text>
              <Text style={F(styles.latoText2)}>{periodLine}</Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.date")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.account")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.name")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.type")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{t("Itrreportsprint.table.loanAmount")}</Text>
                </View>

                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRow}>
                    <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.kno}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.type}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.amt}</Text>
                  </View>
                ))}

                <View style={styles.tableRow3}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.total")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                </View>
              </View>
            </Page>
          ) : irpttype === "karj" ? (
            <Page size="A4">
              <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
              <Text style={F(styles.latoText2)}>{t("Itrreportsprint.titles.karj")}</Text>
              <Text style={F(styles.latoText2)}>{periodLine}</Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.date")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.account")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.name")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.type")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{t("Itrreportsprint.table.loanAmount")}</Text>
                </View>

                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRow}>
                    <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.kno}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.type}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.amt}</Text>
                  </View>
                ))}

                <View style={styles.tableRow3}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.total")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                </View>
              </View>
            </Page>
          ) : irpttype === "sanghpur" ? (
            <Page size="A4">
              <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
              <Text style={F(styles.latoText2)}>{t("Itrreportsprint.titles.sanghpur")}</Text>
              <Text style={F(styles.latoText2)}>{periodLine}</Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.date")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.account")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.name")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.table.type")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{t("Itrreportsprint.table.amount")}</Text>
                </View>

                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRow}>
                    <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.kno}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.type}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.etype}</Text>
                    <Text style={F(styles.tableCell)}>{rowData.amt}</Text>
                  </View>
                ))}

                <View style={styles.tableRow3}>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.total")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeader)}>{t("Itrreportsprint.common.dash")}</Text>
                  <Text style={F(styles.tableHeaderlast)}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                </View>
              </View>
            </Page>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </Document>
    </PDFViewer>
  );
};

// ✅ styles unchanged
const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    flexDirection: "row",
    justifyContent: "center",
  },
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    textAlign: "center",
  },
  tableContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    justifyContent: "space-between",
  },
  table: {
    display: "table",
    width: "97%",
    margin: 5,
  },
  tableone: {
    display: "table",
    width: "18%",
    margin: 5,
  },
  tableCellone: {
    border: "0.5px solid lightgray",
    padding: 0.5,
    fontSize: 8,
    fontFamily: "Lato-Italic",
    textAlign: "center",
    flex: 1,
  },
  tableRowone: {
    flexDirection: "row",
    width: "100%",
  },
  tableHeaderone: {
    fontFamily: "Lato-Italic",
    fontWeight: "bold",
    border: "1px solid #000",
    padding: 2,
    fontSize: 8,
    textAlign: "center",
    flex: 1,
  },

  tableRow: {
    flexDirection: "row",
  },
  tableRow2: {
    flexDirection: "row",
    backgroundColor: "lightgray",
    marginTop: 5,
  },

  tableRow3: {
    flexDirection: "row",
    backgroundColor: "lightgray",
    marginTop: 10,
  },
  line: {
    flexDirection: "row",
    backgroundColor: "lightgray",
    marginTop: 5,
    height: 1,
    width: "100vw",
    marginBottom: 5,
  },
  tableHeader: {
    fontFamily: "Lato-Italic",
    fontWeight: "bold",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: "solid",
    padding: 2,
    flex: 0.5,
    borderColor: "lightblack",
    textAlign: "center",
    fontSize: 9,
  },
  tableHeaderlast: {
    fontFamily: "Lato-Italic",
    fontWeight: "bold",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: "solid",
    borderColor: "lightblack",
    padding: 2,
    flex: 0.5,
    textAlign: "center",
    fontSize: 9,
  },
  tableCell: {
    border: "0.5px solid lightgray",
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontFamily: "Lato-Italic",
    width: 2,
    textAlign: "center",
  },
  tableCellgreen: {
    border: "0.5px solid lightgray",
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Lato-Italic",
    color: "green",
    width: 2,
    textAlign: "center",
  },
  tableCellred: {
    border: "0.5px solid lightgray",
    padding: 0.5,
    flex: 1,
    fontSize: 9,
    fontWeight: "bold",
    fontFamily: "Lato-Italic",
    color: "red",
    width: 2,
    textAlign: "center",
  },
  latoTextlarge: {
    fontFamily: "Lato-Italic",
    fontSize: 15,
    marginBottom: 5,
    textAlign: "center",
    width: "100vw",
    fontWeight: "bold",
    marginTop: 5,
  },
  latoText: {
    fontFamily: "Lato-Italic",
    fontSize: 14,
    marginBottom: -1,
    textAlign: "center",
    width: "100vw",
    fontWeight: "bold",
    marginTop: 2,
  },
  latoText2: {
    fontFamily: "Lato-Italic",
    fontSize: 11,
    textAlign: "center",
    width: "100vw",
    fontWeight: "bold",
  },
  headtextsmall: {
    fontFamily: "Lato-Italic",
    fontSize: 10,
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
  },
  row1: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 5,
    paddingRight: 5,
  },
  row2: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 140,
    paddingRight: 140,
    backgroundColor: "lightgray",
  },
  column1: {
    display: "flex",
    flexDirection: "column",
    width: "19%",
    justifyContent: "start",
    alignItems: "flex-start",
    paddingLeft: 5,
    paddingRight: 5,
    marginLeft: 20,
  },
  column2: {
    display: "flex",
    flexDirection: "column",
    width: "15%",
    justifyContent: "start",
    alignItems: "flex-start",
    paddingLeft: 5,
    paddingRight: 5,
  },
  column3: {
    display: "flex",
    flexDirection: "column",
    width: "17%",
    justifyContent: "start",
    alignItems: "flex-start",
    paddingLeft: 5,
    paddingRight: 5,
    marginLeft: 20,
  },
  column1Row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  column1Rowgray: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: 6,
    marginTop: 5,
    border: "0.5px solid black",
    backgroundColor: "lightgray",
  },
  column1Label: {
    fontFamily: "Lato-Italic",
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "left",
  },
  column1Value: {
    fontFamily: "Lato-Italic",
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "right",
  },
  pageBreak: {
    pageBreakBefore: "always",
  },
  totalsRow: {
    flexDirection: "row",
    borderTop: "1px solid #000",
    paddingTop: 5,
    paddingLeft: 2,
  },
  totalsCell: {
    border: "0.5px solid lightgray",
    padding: 0.5,
    flex: 1,
    fontSize: 8,
    width: 2,
    textAlign: "center",
  },
  imagerow: {
    display: "flex",
    flexDirection: "row",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: 80,
    height: "auto",
    marginLeft: -15,
    marginTop: 5,
  },
  imgtext: {
    fontFamily: "Lato-Italic",
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },
});

export default Itrreportsprint;
